export default "__VITE_ASSET__DbmTg3pv__"